export default "__VITE_ASSET__Awcadh$6K3mZw34GQ8CWdg__"